module.exports = __webpack_public_path__ + "files/SPIADI2026 - DIA INF ADI - Fiche.d5ae177b844d6a8c810d0e400c22d2dd.pdf";